<template>
    <section class="my-14">
        <div class="container">
            <div class="row">
                <div class="col-md-11">
                    <div class="special-heading">
                        <h3>Closinglock Insurance</h3>
                    </div>
                    <div class="col my-3">
                        <p>
                            Download
                            <a
                                class="text-content-primary underline"
                                :href="props.evidenceOfInsuranceUrl"
                                @click="trackDownload"
                            >
                                Evidence of Insurance
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps<{
    evidenceOfInsuranceUrl: string;
    role: string;
    userEmail: string;
    account: string;
}>();

function trackDownload() {
    if (window.amplitude && typeof window.amplitude.track === 'function') {
        window.amplitude.track('download link clicked', {
            'portal type': 'company',
            role: props.role,
            'download link': 'Evidence of Insurance',
            user: props.userEmail,
            account: props.account,
        });
    }
}
</script>
